import React from "react";
import styles from "./MobileLayout.module.scss";
import { MobileStrip } from "../MobileStrip/MobileStrip";
import { Controls } from "../Controls/Controls";
import { MobilePager } from "../MobilePager/MobilePager";
import { TimelineEvent } from "../../model/data";
import { MobilePagerDot } from "../../model/types";

interface MobileLayoutProps {
  yearLeft: string;
  yearRight: string;
  events: TimelineEvent[];
  activeSlideIndex: number;
  onSlideChange: (index: number) => void;
  periodIndex: number;
  pagerDots: MobilePagerDot[];
  count: string;
  onPeriodPrev: () => void;
  onPeriodNext: () => void;
  onPeriodSelect: (index: number) => void;
  isAnimating?: boolean;
}

export const MobileLayout: React.FC<MobileLayoutProps> = ({
  yearLeft,
  yearRight,
  events,
  activeSlideIndex,
  onSlideChange,
  periodIndex,
  pagerDots,
  count,
  onPeriodPrev,
  onPeriodNext,
  onPeriodSelect,
  isAnimating = false,
}) => {
  return (
    <section className={styles.mobile}>
      <h2 className={styles.mTitle}>Исторические даты</h2>

      <div className={styles.mYears} aria-hidden="true">
        <div className={styles.mYearsLeft}>{yearLeft}</div>
        <div className={styles.mYearsRight}>{yearRight}</div>
      </div>

      <div className={styles.mDivider} />

      <div className={styles.content}>
        <MobileStrip
          events={events}
          currentSlideIndex={activeSlideIndex}
          onSlideChange={onSlideChange}
          resetKey={periodIndex}
          isAnimating={isAnimating}
        />
      </div>

      <div className={styles.bottomBar}>
        <Controls
          count={count}
          onPrev={onPeriodPrev}
          onNext={onPeriodNext}
          isAnimating={isAnimating}
        />

        <MobilePager
          dots={pagerDots}
          onDotClick={onPeriodSelect}
          isAnimating={isAnimating}
        />
      </div>
    </section>
  );
};

